import { render, staticRenderFns } from "./business-profile.vue?vue&type=template&id=5c9abdc6&scoped=true"
import script from "./business-profile.vue?vue&type=script&lang=js"
export * from "./business-profile.vue?vue&type=script&lang=js"
import style0 from "./business-profile.vue?vue&type=style&index=0&id=5c9abdc6&prod&scoped=true&lang=css"
import style1 from "./business-profile.vue?vue&type=style&index=1&id=5c9abdc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9abdc6",
  null
  
)

export default component.exports